export enum Doc {
  Pdf = 1,
  Doc,
  Docx,
  Jpg,
  Png,
  Bmp,
  Gif,
  Xlsx,
  Wpd
}
